import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { UPDATE_PROJECT, UPDATE_PROJECT_SUCCESS, UPDATE_PROJECT_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import cogoToast from 'cogo-toast';

function* updateProject({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/projects`,
      method: 'PUT',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(`Program updated successfully`);
      yield put({
        type: UPDATE_PROJECT_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: UPDATE_PROJECT_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_PROJECT_ERROR, payload: error });
  }
}

export function* watchUpdateProject() {
  yield takeEvery(UPDATE_PROJECT, updateProject);
}

function* updateProjectSaga() {
  yield all([fork(watchUpdateProject)]);
}

export default updateProjectSaga;
